import { useCallback, useEffect, useState } from 'react';

type UseModalStateReturnType = [boolean, () => void, () => void];

const useModalState = (isOpened: boolean = false): UseModalStateReturnType => {
  const [isModalOpened, changeModalOpenedState] = useState(isOpened);

  const openModal = useCallback(() => changeModalOpenedState(true), []);
  const closeModal = useCallback(() => changeModalOpenedState(false), []);

  useEffect(() => {
    return () => {
      changeModalOpenedState(false);
    };
  }, []);

  return [isModalOpened, openModal, closeModal];
};

export default useModalState;